var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9095 8.49737C16.9095 10.0681 16.4438 11.6035 15.5711 12.9095C14.6985 14.2155 13.4581 15.2335 12.007 15.8345C10.5558 16.4356 8.95902 16.5929 7.41848 16.2865C5.87794 15.98 4.46287 15.2237 3.3522 14.113C2.24153 13.0023 1.48516 11.5873 1.17872 10.0467C0.872292 8.50617 1.02956 6.90936 1.63065 5.45821C2.23174 4.00705 3.24965 2.76673 4.55566 1.89408C5.86166 1.02144 7.39711 0.555664 8.96783 0.555664C11.0741 0.555664 13.0941 1.39238 14.5835 2.88173C16.0728 4.37109 16.9095 6.3911 16.9095 8.49737Z",
    fill: "url(#paint0_linear_2_13584)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96147 14.7258C7.00377 14.7254 5.11516 14.0021 3.65802 12.6947C2.20089 11.3873 1.27786 9.58781 1.06607 7.6416C1.03568 7.92581 1.02023 8.21143 1.01978 8.49726C1.01978 10.6035 1.85648 12.6235 3.34584 14.1129C4.8352 15.6022 6.8552 16.439 8.96147 16.439C11.0677 16.439 13.0877 15.6022 14.5771 14.1129C16.0665 12.6235 16.9032 10.6035 16.9032 8.49726C16.9027 8.21143 16.8873 7.92581 16.8569 7.6416C16.6451 9.58781 15.7221 11.3873 14.2649 12.6947C12.8078 14.0021 10.9192 14.7254 8.96147 14.7258Z",
    fill: "#E6E6E6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96164 16.6537C7.34989 16.6537 5.77434 16.1758 4.43423 15.2804C3.09411 14.3849 2.04961 13.1122 1.43282 11.6231C0.816031 10.1341 0.654651 8.49556 0.969087 6.91479C1.28352 5.33401 2.05965 3.88198 3.19933 2.7423C4.33901 1.60262 5.79104 0.826492 7.37182 0.512056C8.9526 0.19762 10.5911 0.359 12.0802 0.975788C13.5692 1.59258 14.842 2.63707 15.7374 3.97719C16.6328 5.31731 17.1108 6.89286 17.1108 8.50461C17.1064 10.6645 16.2464 12.7347 14.7191 14.262C13.1918 15.7894 11.1216 16.6493 8.96164 16.6537ZM8.96164 0.770337C7.43341 0.770337 5.93951 1.22351 4.66883 2.07255C3.39815 2.92159 2.40778 4.12836 1.82295 5.54026C1.23813 6.95216 1.08511 8.50577 1.38325 10.0046C1.68139 11.5035 2.4173 12.8803 3.49792 13.9609C4.57854 15.0415 5.95534 15.7774 7.45421 16.0756C8.95307 16.3737 10.5067 16.2207 11.9186 15.6359C13.3305 15.0511 14.5373 14.0607 15.3863 12.79C16.2353 11.5193 16.6885 10.0254 16.6885 8.4972C16.687 6.44819 15.8725 4.48349 14.4238 3.03445C12.9751 1.58541 11.0106 0.772299 8.96164 0.770337Z",
    fill: "#C69C6D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5491 9.86203L10.4731 12.8254L8.18396 12.4235L8.27842 10.0584L5.39844 10.2436L5.55031 7.93587L8.32842 7.75067L8.42473 4.75586L10.7139 5.13739L10.6176 7.57842L13.2105 7.39321L13.0382 9.70275L10.5491 9.86203Z",
    fill: "#B3B3B3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1213 9.4343L10.0435 12.3976L7.75437 11.9957L7.85068 9.63062L4.9707 9.81583L5.12257 7.50814L7.90069 7.32293L7.99514 4.32812L10.2843 4.70965L10.1899 7.15069L12.7828 6.96548L12.6124 9.27317L10.1213 9.4343Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_13584",
    x1: 8.96782,
    y1: 1.54044,
    x2: 8.96782,
    y2: 13.5642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#F18162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45C26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.eabb30776758275599f536446ca524aa.svg";
export { ForwardRef as ReactComponent };